import { render } from "./App.vue?vue&type=template&id=4ab7f8ef"
const script = {}

import "./App.vue?vue&type=style&index=0&id=4ab7f8ef&lang=stylus"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__